import wrapperHOC from "@Utils/wrapperHOC";
import Rail from "../Testimonials/Rail";
import { STUDY_CARDS } from "../Testimonials/cards";

/**
 * "Case Studies" — the four partner studies, on their own rail.
 *
 * ⚠️  IT IMPORTS FROM `../Testimonials/`, and that is not an oversight. The rail
 * and the card data were already there when this was one combined section; both
 * sections draw the same card shapes from the same source, so the alternative
 * was a third folder holding two files that only these two components use.
 * `Rail.tsx` and `cards.ts` are the shared pair — if a third rail ever appears,
 * that is the moment to move them somewhere neutral.
 *
 * ⚠️  THE HEADING IS A NEW KEY, English-only for now:
 * `list.v2.casestudies.heading` — "How partnerships pay off". Both the existing
 * candidates were wrong: `list.casestudies.title` reads "Case Studies &
 * Testimonials", the combined label from when these were one section, and
 * `list.casestudies.titleMobile` just names the format. It needs its other six
 * locales before a localised route; see the same note in `Testimonials`.
 */
const CaseStudies = () => (
  <Rail heading="list.v2.casestudies.heading" items={STUDY_CARDS} divided />
);

export default wrapperHOC(CaseStudies, {
  componentName: "CaseStudies-ListWithUs",
  showForChina: true,
});
